import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingContact from "@/components/layout/FloatingContact";
import Home from "@/pages/Home";
import Tours from "@/pages/Tours";
import TourDetail from "@/pages/TourDetail";
import RequestQuote from "@/pages/RequestQuote";
import About from "@/pages/About";
import Why from "@/pages/Why";
import Contact from "@/pages/Contact";
import AdminInquiries from "@/pages/AdminInquiries";
import PastTrips from "@/pages/PastTrips";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/college-tours" element={<Tours initialFilter="College Tour" />} />
            <Route path="/group-travel" element={<Tours initialFilter="Group Travel" />} />
            <Route path="/tours" element={<Tours />} />
            <Route path="/tours/:slug" element={<TourDetail />} />
            <Route path="/request-quote" element={<RequestQuote />} />
            <Route path="/about" element={<About />} />
            <Route path="/why-knv" element={<Why />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/past-trips" element={<PastTrips />} />
            <Route path="/admin/inquiries" element={<AdminInquiries />} />
          </Routes>
        </main>
        <Footer />
        <FloatingContact />
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
